import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FateDropdown } from 'fate-editor';

/**Componente per la dropdown delle citazioni dei codici legali */
@Component({
  selector: 'app-legal-code-dropdown',
  templateUrl: '../quote-template.html',
  styleUrls: ['../editor-dropdowns.css']
})
export class LegalCodeDropdownComponent implements FateDropdown {
  /**Input, la stringa eventualmente selezionata */
  @Input()
  public value: string;
  /**Emettitore per il valore selezionato dalla dropdown */
  @Output() public valueChange = new EventEmitter<string>();

  /**Elenco delle citazioni possibili */
  noteList = [
    {
      etichetta: 'Rambàm',
      valore: 'Rambàm'
    },
    {
      etichetta: 'Tur e Shulchàn ‘Arùkh, Òrach Chayìm',
      valore: 'Tur e Shulchàn ‘Arùkh, <i>Òrach Chayìm</i>'
    },
    {
      etichetta: 'Tur e Shulchàn ‘Arùkh, Yorè De‘à',
      valore: 'Tur e Shulchàn ‘Arùkh, <i>Yorè De‘à</i>'
    },
    {
      etichetta: 'Tur e Shulchàn ‘Arùkh, Chòshen Mishpàt',
      valore: 'Tur e Shulchàn ‘Arùkh, <i>Chòshen Mishpàt</i>'
    },
    {
      etichetta: 'Tur e Shulchàn ‘Arùkh, Èven ha‘Èzer',
      valore: 'Tur e Shulchàn ‘Arùkh, <i>Èven ha‘Èzer</i>'
    }
  ]; 

  /**Indice elemento selezionato */
  public selected = 0;

  /**
   * Metodo che gestisce l'emissione del valore selezionato
   * @param value {any} il valore selezionato
   */
  public changeValue(value) {
    this.valueChange.emit(value);
  }

  /**Metodo che gestisce la selezione del successivo */
  public selectNext() {
    this.selected++;
    if (this.selected >= this.noteList.length) {
      this.selected = this.noteList.length - 1;
    }
  };

  /**Metodo che gestisce la selezione del precedente */
  public selecPrevious() {
    this.selected--;
    if (this.selected < 0) {
      this.selected = 0;
    }
  };

  /**Metodo che conferma la selezione lanciando il metodo di cambio valore */
  public confirmSelection() {
    this.changeValue(this.noteList[this.selected]);
  };
  constructor() { }

}
